export const ORDER_DOCUMENTS_SECTION = 'documents-section';
export const ORDER_DETAILS_SDS_DOCUMENT_TYPE = 'SDS';
export const ORDER_DETAILS_TDS_DOCUMENT_TYPE = 'TDS';
export const ORDER_DETAILS_SDS_DOCUMENT_TYPE_DROPDOWN = 'safetyDataSheet';
